import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface ISurNameField {
	changeSurName: (value: string) => void;
}

const SurNameField: React.FC<ISurNameField> = ({ changeSurName }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterSurname') }], [t]);

	return (
		<FormInput
			testId="SurNameField"
			name="surName"
			label="surnameLabel"
			onChange={changeSurName}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(SurNameField);
